import * as graphql from 'generated/graphql';
import { useWorkspace } from 'packages/kakapo-ui-services/hooks/useWorkspace';

export default function useWorkspaceConfiguration(): {
	data?: {
		redirect?: string;
		startDate?: string;
		singleSignOns?: { url: string }[];
		supportedLanguageIDs?: string[];
	};
	loading: boolean;
} {
	const { data, loading } = graphql.useWorkspaceConfigurationQuery({
		variables: {
			id: useWorkspace().id,
		},
	});

	if (loading) {
		return { loading };
	} else {
		if (!data) {
			return { data: undefined, loading: false };
		}

		return {
			data: {
				redirect: data?.workspace.redirect ?? undefined,
				startDate: data?.workspace.startDate,
				supportedLanguageIDs: data?.workspace.supportedLanguageIDs,
				singleSignOns: data?.singleSignOns,
			},
			loading: false,
		};
	}
}
